import React from 'react';
import { IconSpan } from '../../../../components/IconSpan';

export interface MenuAction {
  action: () => void;
  buttonChild: React.ReactNode;
}

export const buildMenuAction = (
  action: () => void,
  label: string,
  iconName: string,
): MenuAction => ({
  action,
  buttonChild: (
    <IconSpan
      spanText={label}
      icon={{ name: iconName, className: 'fs-4' }}
      className='text-blue'
    />
  ),
});
